module.exports = __webpack_public_path__ + "img/illu-stitches.89287bda.svg";